import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErddapService {

  constructor() {
  }

  generateDataUrl(datasetId, variables, fileFormat) {
    return "https://ceotr.ocean.dal.ca/erddap/tabledap/" + datasetId + fileFormat + "?" + this.percentEncode(variables.toString());
  }

  generateMetadataUrl(datasetId, fileFormat) {
    return "https://ceotr.ocean.dal.ca/erddap/info/" + datasetId + "/index" + fileFormat;
  }

  /**
  Replace \xA0 (non-breaking space) with a regular space and then encodeURI
   */
  percentEncode(s: string) {
    return encodeURIComponent(s.replace('\xA0', ' '));
  }
}
